import React from 'react'
import { SVGIconProps } from 'commonTypes'
import CompoundsIcon from './CompoundsIcon'
import DnaIcon from './DnaIcon'
import TargetIcon from './TargetIcon'

export type MenuIconTypes =
    | 'Compounds'
    | 'Targets'
    | 'Alterations detected'

type MenuIconProps = SVGIconProps & {
    type: MenuIconTypes
}

const MenuIcons: React.FC<MenuIconProps> = ({ type, fill, ...props }) => {
    switch (type) {
        case 'Compounds':
            return <CompoundsIcon fill={fill} {...props} />

        case 'Targets':
            return <TargetIcon fill={fill} {...props} />

        case 'Alterations detected':
            return <DnaIcon fill={fill} {...props} />

        default:
            return null
    }
}

export default MenuIcons